import pkg from '../../package.json'

export default pkg?.version
